import { login } from '@features/auth/auth.slice';
import { useResetPasswordMutation } from '@services/core/auth/auth.endpoints';
import { ResetPasswordRequest } from '@services/core/auth/auth.types';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

export const useResetPasswordPageVM = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [token, setToken] = useState<string | null>(null);

    const [resetPassword, { isLoading, isSuccess, data, isError, error }] = useResetPasswordMutation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');
        if (token) {
            setToken(token);
        }
    }, [location.search]);

    const handleSubmit = async (values: ResetPasswordRequest) => {
        resetPassword({ token: values.token, password: values.password, confirm_password: values.confirm_password });
    };

    useEffect(() => {
        if (isError && error) {
            console.log('error', error);
            return;
        }
        if (isSuccess && data) {
            dispatch(login({ ...data.data.user, jwt: data.data.jwt }));
            navigate('/members-management');
            return;
        }
    }, [isSuccess, isError]);

    return {
        handleSubmit,
        isLoading,
        token
    };
};
